import { render, staticRenderFns } from "./AdminPagination.vue?vue&type=template&id=2f201fd4&scoped=true"
import script from "./AdminPagination.vue?vue&type=script&lang=js"
export * from "./AdminPagination.vue?vue&type=script&lang=js"
import style0 from "./AdminPagination.vue?vue&type=style&index=0&id=2f201fd4&prod&lang=css"
import style1 from "./AdminPagination.vue?vue&type=style&index=1&id=2f201fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f201fd4",
  null
  
)

export default component.exports